import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { OpportunityStatuses } from '@models/enums/OpportunityStatuses';
import { OpportunityStatusIndicatorConfig } from '../opportunity-status-indicator.component';

@Component({
    selector: 'app-opportunity-status-actions-menu',
    standalone: true,
    templateUrl: './opportunity-status-actions-menu.component.html',
    styleUrls: ['./opportunity-status-actions-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class OpportunityStatusActionsMenuComponent {
    config = input.required<OpportunityStatusIndicatorConfig>();

    disqualifyToggleClick = output<void>();

    manualStatusClick = output<void>();

    opportunityStatuses = OpportunityStatuses;

    onDisqualifyToggleClick(event: Event): void {
        event.stopPropagation();
        this.disqualifyToggleClick.emit();
    }

    onManualStatusClick(event: Event): void {
        event.stopPropagation();
        this.manualStatusClick.emit();
    }
}
